
import React, { Component } from 'react'
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import axios from 'axios';

export default class  ViewAuditAgremeents extends Component {
    constructor(props) {
        super(props)
        this.state = {
            orgCode : props.match.params.orgcode,
            data: {},
            editStatus:false,
            showMessage:false,
            isLoading:false
        }    
    }
    componentDidMount() {
        const api= APIURL + '/api/rfq/get/orgdetails/'+this.state.orgCode
        axios.get(api, {headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
         }})
            .then(res => {
                // this.setState({ data: res.data.response })
                // console.log("data",res.data.response)masteragreementStatus
                if(res.data.errorCode === 0){
                    this.setState({data : res.data.response,url: res.data.response.masterAgreementUrl})
                    console.log("view agreement",res.data.response)
                    if(res.data.response.contractreviewStatus  && res.data.response.masteragreementStatus)
                    {
                        this.setState({editStatus:true})
                        // if ( this.state.data.masterAgreementUrl) {
                        //     this.setState({ uploadedProcessUrl: this.state.data.masterAgreementUrl })
                        //     this.setState({ uploadDocumentStatus: "none", uploadedDocumentStatus: "block",downloadbuttonStatus:"none" })
                        // }
                        // else if (! this.state.data.masterAgreementUrl) {
                        //     this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none",downloadbuttonStatus:"block" })
                        // }
                    } else if(res.data.response.contractreviewStatus && !res.data.response.masteragreementStatus)
                    {
                        this.setState({editStatus:true,message:"Aggrement Copy is still Not Uploaded",showMessage:true})
                    } else{
                        this.setState({ editStatus: false , message:"This Company's Contract Review Checklist is not filled.",showMessage:true})
                    }
                }
            })
            .catch(e=>{
                console.log("Something went Wrong", e)
                var string = JSON.stringify(e).split("/")[0]
                const regex = /401/g;
                const found = string.match(regex);

                console.log("found", found);
                if (found !== null) {
                    window.location.href = "/signin"
                    //alert("if")
                    this.setState({isLoading:true})
                }
            })
    }
    downloadSignedPdf = () => {
        const link = document.createElement('a');
        console.log("link",link)
        link.href = this.state.url
        window.open(link)
      

    }
    handleRoute = () => {
        window.location.href = "/"+localStorage.getItem("role")+'/auditagreements/'+this.state.orgCode
    }
    render() {
        if(this.state.isLoading){
            return(<h1>Loading</h1>)
        }
        return(
            <div>
            <div className="content-wrapper">
                       <section className="content">
                           <div className="container-fluid">
                               <div className="row">
                               {
                                this.state.showMessage  ?

                                    <div className="text-center"><p style={{fontSize:"25Px" ,color:"red"}}>{this.state.message}</p></div>
                                :
                                    null
                            }
                                   <div className="col-sm-12">
                                       <div className="card-body" style={{ paddingLeft: "4rem",paddingTop:"1rem",paddingRight:"6rem",minHeight:"450px"}}>
                                           <div className="row">
                                               <div className="col-sm-12">
                                                    <div className="row">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Organization Name</label>
                                                        <div className="col-sm-9">
                                                        <p>{this.state.data.orgName}</p>
                                                        </div>
                                                    </div>  

                                                    <div className="row  mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Master Agreement</label>
                                                        <div className="col-sm-9">
                                                        <p>
                                                        {
                                                             this.state.data && this.state.data.masterAgreementUrl  &&   this.state.data.masterAgreementUrl.match(/\.(jpg|jpeg|png|gif)$/) ?
                                                                    <>
                                                                        <img className="img-fluid" src={this.state.data.masterAgreementUrl} style={{ width: '80px', height: '80px' }} />
                                                                        
                                                                    </>
                                                                    :
                                                                    this.state.data && this.state.data.masterAgreementUrl  &&  this.state.data.masterAgreementUrl.match(/\.(pdf)$/) ?
                                                                        <>
                                                                        <button className="btn btn-sm btn-success"onClick={()=>this.downloadSignedPdf()}>Download Signed Agreement</button>
                                                                        </>

                                                                        :
                                                                        <div>Master Agreement is not yet signed</div>
                                                            }
                                                            </p>
                                                        </div>
                                                    </div> 
                                               </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    { 
                        localStorage.getItem("userRole")==="Management" || localStorage.getItem("userRole")==="Lead Auditor" || localStorage.getItem("userRole")==="Auditor" || localStorage.getItem("userRole")==="Asst Auditor" || localStorage.getItem("userRole")==="Accounts" ?
                                            ""
                            :
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-sm-10"></div>
                            <div className="col-sm-2">
                            {this.state.editStatus ?
                                    <button type="submit" className="btn btn-primary float-right" onClick={() => { this.handleRoute() }}>Edit</button>
                             :<></>  
                                     }   
                                {/* <button type="submit" className="btn btn-primary float-right" onClick={() => { this.handleRoute() }}>Edit</button> */}
                            </div>
                        </div>
                    </div>
    }
                </div>   
          )
    }
}

